import {IEntryType} from '../_interface/ientry-type';
import {UNKNOWN_ENTRY_TYPE} from 'shared/defaults';

export const enhanceWithEntryType = <T>(input: any & { entryTypeId: string }, types: IEntryType[]): T & { entryType: IEntryType } => {
	const entryType = types.find(i => i.entryTypeId === input.entryTypeId) || UNKNOWN_ENTRY_TYPE;
	return {
		...input,
		entryType
	};
};
